import { createBrowserRouter } from "react-router-dom";
import Layout from 'components/Layout';
import Main from 'components/pages/Main';
import Contract from 'components/pages/Contract';
import ToolbarTest from 'components/pages/ToolbarTest';

export default createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Main />
      },
      {
        path: '/contract',
        element: <Contract />
      },
      {
        path: '/toolbar-test',
        element: <ToolbarTest />
      },
    ]
  },
]);